import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { CheckCircle2, XCircle, Info } from "lucide-react";
import { cn } from "@/lib/utils";
const ToastContext = createContext(null);
export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);
    const show = useCallback((type, message, durationMs = 3000) => {
        const id = Math.random().toString(36).slice(2);
        setToasts((prev) => [...prev, { id, type, message }]);
        if (durationMs > 0) {
            setTimeout(() => {
                setToasts((prev) => prev.filter((t) => t.id !== id));
            }, durationMs);
        }
    }, []);
    return (_jsxs(ToastContext.Provider, { value: { show }, children: [children, _jsx("div", { className: "dark fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none", "aria-live": "polite", role: "status", children: toasts.map((t) => (_jsx(ToastView, { toast: t, onDismiss: () => setToasts((prev) => prev.filter((x) => x.id !== t.id)) }, t.id))) })] }));
}
function ToastView({ toast, onDismiss }) {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        requestAnimationFrame(() => setVisible(true));
    }, []);
    const Icon = toast.type === "success" ? CheckCircle2 : toast.type === "error" ? XCircle : Info;
    const palette = toast.type === "success"
        ? "bg-green-500/10 border-green-500/40 text-green-300"
        : toast.type === "error"
            ? "bg-destructive/15 border-destructive/40 text-destructive"
            : "bg-card border-border text-foreground";
    return (_jsxs("button", { onClick: onDismiss, className: cn("pointer-events-auto flex items-center gap-2 rounded-md border px-4 py-2 text-sm shadow-lg backdrop-blur transition-all min-w-[200px] max-w-md text-left", palette, visible ? "translate-x-0 opacity-100" : "translate-x-4 opacity-0"), children: [_jsx(Icon, { className: "h-4 w-4 shrink-0" }), _jsx("span", { children: toast.message })] }));
}
export function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx)
        throw new Error("useToast must be used inside <ToastProvider>");
    return ctx;
}
